module.exports = "//public.zight.com/packs/media/images/integrations-54c4911099f798394670e37def7f438b.svg";